import type { ReactNode } from 'react';

/**
 * The status page's one surface: a white sheet cleared on the grid (callers
 * add `data-grid-block data-grid-fill="#ffffff"`), framed with its own border
 * and rounding only below md — on the grid the clearing's kept border lines
 * are the frame. Every sheet opens with a one-row header bar whose bottom
 * hairline lands on a grid row line, so the sheets read as one family.
 */
export const SHEET =
  'overflow-hidden rounded-[6px] border border-line bg-surface md:rounded-none md:border-0 md:bg-transparent';

export const SHEET_ROW = 'md:h-[var(--grid-cell,72px)]';

export function SheetHeader({
  id,
  title,
  note,
  noteClassName = 'hidden sm:inline',
}: {
  id: string;
  title: ReactNode;
  note?: ReactNode;
  noteClassName?: string;
}) {
  return (
    <div
      className={`flex items-center justify-between gap-4 border-b border-line px-5 font-jetbrains text-[10.5px] tracking-[0.14em] text-dim max-md:py-3 ${SHEET_ROW}`}
    >
      <h2 id={id}>{title}</h2>
      {note && <span className={noteClassName}>{note}</span>}
    </div>
  );
}

/** One-row sheet body line for plain-sentence empty states. */
export function SheetLine({ children }: { children: ReactNode }) {
  return <p className={`flex items-center px-5 text-[15px] text-ink max-md:py-4 ${SHEET_ROW}`}>{children}</p>;
}
